module.exports = __webpack_public_path__ + "static/3-5504d727c0e330e207dd844d29446c0f.png";